"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventIcon = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var PageStatusIcon_1 = require("@CommonFrontend/Project/PageStatusIcon");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Engagement_1 = require("Common/Engagement");
var styles = __importStar(require("./Timeline.css"));
var EventIcon = function (_a) {
    var rowData = _a.rowData;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.eventIconFrame, align: "center", justify: "center" }, getIcon(rowData)));
};
exports.EventIcon = EventIcon;
function getIcon(_a) {
    var eventData = _a.eventData;
    switch (eventData.eventType) {
        case "pageStatus":
            if (eventData.changeSource === Types_1.PageStateChangeSource.PageCreation) {
                return react_1.default.createElement(icons_1.Page, null);
            }
            else {
                return react_1.default.createElement(PageStatusIcon_1.PageStatusIcon, { status: eventData.status });
            }
        case "engagementLevel":
            return react_1.default.createElement(Engagement_1.EngagementIcon, { engagementLevel: eventData.engagementLevel });
        case "pageView":
            return react_1.default.createElement(icons_1.Preview, null);
    }
}
